export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/measurements.worker.a96ed35b.js");
}
